/**
 * SynthesisBlock.jsx
 * ---------------------------------------------------------------------------
 * The closing synthesis block from §5 of the brief. Used at the bottom of
 * the Overview subtab and again, in shorter form, on Validation & Procurement.
 */

import React from "react";
import { cxTokens as t } from "../../lib/coconsolexTokens.js";

export default function SynthesisBlock({ short = false }) {
  return (
    <section
      style={{
        marginTop: 56,
        background: t.ink,
        color: t.cream,
        padding: "40px 36px",
      }}
    >
      <div
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontStyle: "italic",
          fontSize: 14,
          letterSpacing: "0.22em",
          color: "#A3BFFA",
          textTransform: "uppercase",
          marginBottom: 12,
        }}
      >
        Closing Synthesis
      </div>
      {!short && (
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 16, lineHeight: 1.7, margin: "0 0 16px" }}>
          What CaseSignalHQ proposes — established client access, signed
          confidentiality agreements, one-way updates, no internet
          connectivity — gets you most of the way there. The gaps that remain
          are operational (identity, segregation, audit), continuity (backup,
          disaster recovery), lifecycle (decommissioning, sunset), and
          structural (insurance, jurisdiction, equity).
        </p>
      )}
      <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 16, lineHeight: 1.7, margin: "0 0 16px" }}>
        Each of those has an established best-in-class answer drawn from
        adjacent industries — the IC for air-gap and diodes, defense
        contracting for facility clearance and CMMC, financial services for
        BCP and continuity, healthcare for data residency, and the legal
        industry's own established practices for co-counsel engagement,
        conflicts management, and malpractice coverage.
      </p>
      <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 16, lineHeight: 1.7, margin: 0 }}>
        CoConsoleX's strength is that none of the answers are inventions. Each
        one is a well-established practice in some adjacent industry,
        transposed into legal AI deployment under the doctrinal cover of the
        lawyer-to-lawyer engagement model. CaseSignalHQ's contribution is the
        synthesis and the doctrinal frame — the recognition that these
        existing patterns, properly assembled, produce a deployment model that
        addresses the structural confidentiality gap that contractual
        safeguards cannot close.
      </p>
      {!short && (
        <>
          <div
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontStyle: "italic",
              fontSize: 14,
              letterSpacing: "0.22em",
              color: "#A3BFFA",
              textTransform: "uppercase",
              marginTop: 28,
              marginBottom: 10,
            }}
          >
            Where this leads
          </div>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 16, lineHeight: 1.7, margin: 0 }}>
            This is the body of work that becomes the standard. And once it
            exists with CaseSignalHQ's imprint, the AI companies, the law
            firms, and the eventual operators of CoConsoleX-type entities all
            have a citable framework to point to — and CaseSignalHQ is the
            institution that defined it.
          </p>
        </>
      )}
    </section>
  );
}
